import { useAppDispatch } from '@app/hooks';
import { apiSlice } from '@features/api/apiSlice';
import { ResetPassword } from '@features/api/request/ResetPassword';
import {
  useLogoutMutation,
  useSendEmailVerificationRequestMutation,
  useSendPasswordResetRequestMutation,
  useSignUpMutation,
} from '@features/api/userSlice';
import { SignUpFormData } from '@pages/SignUp/SignUp.types';
import { SignUpInvitesOnly } from '@utils/environmentVariables/environmentVariables';
import { capitalize } from '@utils/functions/stringManipulation';
import moment from 'moment';

export const useAuth = () => {
  const dispatch = useAppDispatch();
  const [signUpMutation] = useSignUpMutation();
  const [logoutMutation] = useLogoutMutation();
  const [sendPasswordResetRequestMutation] =
    useSendPasswordResetRequestMutation();
  const [sendEmailVerificationRequestMutation] =
    useSendEmailVerificationRequestMutation();

  const signUp = async ({
    residenceCountry,
    firstName,
    middleName,
    surname,
    emailAddress,
    password,
    birthDate,
    inviteCode,
    isQualifiedInvestor,
  }: SignUpFormData) => {
    /* eslint-disable @typescript-eslint/no-non-null-assertion */
    await signUpMutation({
      countryOfResidence: residenceCountry!,
      firstName: capitalize(firstName!),
      middleName: capitalize(middleName!),
      lastName: capitalize(surname!),
      email: emailAddress!.toLowerCase(),
      password: password!,
      dob: moment(birthDate).format('YYYY-MM-DD'),
      qualifiedInvestor: !!isQualifiedInvestor,
      ...(SignUpInvitesOnly && { inviteCode: inviteCode }),
    }).unwrap();
    /* eslint-enable @typescript-eslint/no-non-null-assertion */
  };

  const sendEmailVerificationRequest = async () => {
    await sendEmailVerificationRequestMutation().unwrap();
  };

  const sendPasswordResetRequest = async (data: ResetPassword) => {
    await sendPasswordResetRequestMutation({
      email: data.email.toLowerCase(),
    }).unwrap();
  };

  const logout = async () => {
    await logoutMutation().unwrap();
    dispatch(apiSlice.util.resetApiState());
  };

  const revokeAccessTokens = async () => {
    // Not used anymore
  };

  return {
    signUp,
    logout,
    sendEmailVerificationRequest,
    sendPasswordResetRequest,
    revokeAccessTokens,
  };
};
